import { Chip, chipClasses, lighten, styled } from '@/core/ui';
import { quantityChipMinWidthSpacingArgument } from './constants';
export const ChipStyled = styled(Chip)(({ theme, color }) => ({
    minWidth: theme.spacing(quantityChipMinWidthSpacingArgument),
    backgroundColor: color === 'primary'
        ? lighten(theme.palette.primary.lightest, 0.2)
        : color === 'secondary'
            ? lighten(theme.palette.secondary.lightest, 0)
            : color === 'yellow'
                ? lighten(theme.palette.yellow.lightest, 0.1)
                : color,
    [`.${chipClasses.label}`]: {
        lineHeight: '1rem',
        fontSize: theme.typography.caption.fontSize,
    },
}));
// TODO: to delete if not used
// export const SkeletonStyled = styled(Skeleton)(({ theme }) => ({
// 	display: 'inline-block',
// 	width: theme.spacing(quantityChipMinWidthSpacingArgument),
// 	height: theme.spacing(6),
// 	lineHeight: theme.spacing(4),
// 	paddingBlock: theme.spacing(1),
// 	borderRadius: '9999px',
// }));
